module.exports = "/fonts/vendor/vue-img-inputer/dist/iconfont.ttf?66ad88d08dd1b9a7a7a358b821da59dc";